export function Commerce() {
  const $document = jQuery(document);
  const namespace = '.noahsCommerce';

  Drupal.behaviors.noahsCommerceCart = {
    attach() {
      $document
        .off(namespace)
        .on(`click${namespace}`, '.noahs-commerce-cart__toggle', function (event) {
          event.preventDefault();
          const $button = jQuery(this);
          const $cart = $button.closest('.noahs-commerce-cart');
          const isExpanded = $button.attr('aria-expanded') === 'true';

          if (isExpanded) {
            $button.attr('aria-expanded', 'false');
            jQuery('.noahs-commerce-cart-sidebar').remove();
            return;
          }

          $button.attr('aria-expanded', 'true');
          if (jQuery('.noahs-commerce-cart-sidebar').length || $cart.data('loading')) return;

          const url = drupalSettings?.noahs_page_builder_pro?.cart_sidebar_url;
          if (!url) {
            $button.attr('aria-expanded', 'false');
            return;
          }

          $cart.data('loading', true).attr('aria-busy', 'true');
          jQuery.get(url)
            .done((html) => {
              jQuery('.noahs-commerce-cart-sidebar').remove();
              jQuery('body').append(html);
            })
            .fail(() => $button.attr('aria-expanded', 'false'))
            .always(() => $cart.removeData('loading').removeAttr('aria-busy'));
        })
        .on(`click${namespace}`, '.noahs-commerce-cart-sidebar__remove', function (event) {
          event.preventDefault();
          const $button = jQuery(this);
          const $item = $button.closest('.noahs-commerce-cart-sidebar__item');
          const orderItemId = $item.data('order-item-id');
          const pattern = drupalSettings?.noahs_page_builder_pro?.cart_remove_url_pattern;

          if (!pattern || !orderItemId || $item.hasClass('is-removing')) return;

          $item.addClass('is-removing').attr('aria-busy', 'true');
          $button.prop('disabled', true);
          jQuery.ajax({
            url: pattern.replace(/0$/, orderItemId),
            method: 'POST',
            headers: { 'X-CSRF-Token': drupalSettings.csrfToken },
            dataType: 'json',
          })
            .done((response) => {
              if (response.status !== 'ok') return;
              if (response.html) jQuery('.noahs-commerce-cart-sidebar').replaceWith(response.html);
              jQuery('.noahs-commerce-cart-sidebar__summary__count, .cart-block--summary__count').text(response.count);
              jQuery('.cart-block--summary__total').text(response.total_price);
            })
            .always(() => {
              $item.removeClass('is-removing').removeAttr('aria-busy');
              $button.prop('disabled', false);
            });
        })
        .on(`click${namespace}`, '.noahs-commerce-cart-sidebar__close', function (event) {
          event.preventDefault();
          jQuery('.noahs-commerce-cart__toggle').attr('aria-expanded', 'false');
          jQuery('.noahs-commerce-cart-sidebar').remove();
        });
    },

    detach(context, settings, trigger) {
      if (trigger === 'unload' && context === document) $document.off(namespace);
    },
  };

  Drupal.behaviors.noahsCommerceCart.attach(document);
}
